var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    {
      staticClass: "table-widget",
      attrs: { widget: _vm.widget },
      scopedSlots: _vm._u(
        [
          {
            key: "headerContent",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "header-container flex--justify-end" },
                  [
                    _vm._t("headerContent"),
                    _vm._v(" "),
                    _vm.enableDateRangeFilter
                      ? _c(
                          "v-select",
                          _vm._b(
                            {
                              staticClass: "v-select m-r-10",
                              attrs: { options: _vm.dateRangeOptions },
                              model: {
                                value: _vm.selectedDateRange,
                                callback: function($$v) {
                                  _vm.selectedDateRange = $$v
                                },
                                expression: "selectedDateRange"
                              }
                            },
                            "v-select",
                            _vm.selectOptions,
                            false
                          )
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.enableSearch
                      ? _c("div", { staticClass: "m-r-15" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filters.name.value,
                                expression: "filters.name.value"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              size: "28",
                              type: "text",
                              placeholder: _vm.searchPlaceholder
                            },
                            domProps: { value: _vm.filters.name.value },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.filters.name,
                                  "value",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.enableExport
                      ? _c(
                          "btn",
                          {
                            staticClass: "btn btn-sm m-r-15 export-btn",
                            attrs: {
                              disabled: _vm.exportTableContent.length == 0
                            },
                            on: {
                              click: function($event) {
                                return _vm.exportTable()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("EXPORT_CSV")) +
                                "\n      "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "Dropdown",
                      {
                        ref: "dropdown",
                        staticClass:
                          "bulk-actions-dropdown pull-right column-toggle",
                        attrs: {
                          tag: "span",
                          "menu-right": true,
                          "not-close-elements": _vm.lockedElements
                        },
                        on: {
                          "hook:mounted": function($event) {
                            _vm.lockedElements = [_vm.$refs.dropdown.$el]
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "dropdown",
                            fn: function() {
                              return _vm._l(_vm.toggleColumns, function(
                                setting,
                                i
                              ) {
                                return _c("li", { key: i }, [
                                  _c("div", { staticClass: "menu-item" }, [
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for: setting.headerName + _vm._uid
                                        }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model.lazy",
                                              value: setting.show,
                                              expression: "setting.show",
                                              modifiers: { lazy: true }
                                            }
                                          ],
                                          attrs: {
                                            id: setting.headerName + _vm._uid,
                                            type: "checkbox",
                                            name: setting.headerName
                                          },
                                          domProps: {
                                            checked: Array.isArray(setting.show)
                                              ? _vm._i(setting.show, null) > -1
                                              : setting.show
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = setting.show,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      setting,
                                                      "show",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      setting,
                                                      "show",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(setting, "show", $$c)
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                _vm.toggledColumnDefs[i]
                                                  .headerName
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                ])
                              })
                            },
                            proxy: true
                          }
                        ])
                      },
                      [
                        _c("button", [
                          _c("span", { staticClass: "typcn typcn-cog" })
                        ])
                      ]
                    )
                  ],
                  2
                )
              ]
            },
            proxy: true
          }
        ],
        null,
        true
      )
    },
    [
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-area" },
        [
          _c(
            "keep-alive",
            [
              _c(
                "transition",
                {
                  staticClass: "o",
                  attrs: {
                    mode: "out-in",
                    type: "transition",
                    "appear-class": _vm.inClass,
                    "appear-active-class": _vm.inClass,
                    "leave-active-class": _vm.outClass,
                    "leave-to-class": _vm.outClass
                  }
                },
                [
                  _vm.$slots.table
                    ? _c(
                        "TransitionComp",
                        {
                          key: "1",
                          staticClass: "animated overflow-hidden relative"
                        },
                        [_vm._t("table")],
                        2
                      )
                    : _c(
                        "TransitionComp",
                        { key: "5", staticClass: "overflow-hidden animated" },
                        [
                          _c("SmartTable", {
                            attrs: {
                              "column-defs": _vm.toggledColumnDefs,
                              "row-data": _vm.rowData,
                              locale: _vm.widget.locale,
                              filters: _vm.filters
                            },
                            on: {
                              click: function($event) {
                                return _vm.$emit(
                                  "click:cell",
                                  $event.row[$event.col.key]
                                )
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "cell",
                                  fn: function(cellProps) {
                                    return [
                                      _c(
                                        "Popover",
                                        {
                                          attrs: {
                                            target:
                                              _vm.$refs.currentSelectedCell,
                                            trigger: "manual",
                                            placement: "right",
                                            "custom-class":
                                              "popover--slim popover--smart-table"
                                          },
                                          model: {
                                            value: _vm.showPopover,
                                            callback: function($$v) {
                                              _vm.showPopover = $$v
                                            },
                                            expression: "showPopover"
                                          }
                                        },
                                        [
                                          _vm._t(
                                            "cell",
                                            function() {
                                              return [
                                                _vm.enablePopoverOnClick &&
                                                cellProps.value &&
                                                cellProps.value !== "0" &&
                                                cellProps.value !== "-" &&
                                                cellProps.col.cellClass !==
                                                  "no-click"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        ref: _vm.createCellIdentificationData(
                                                          cellProps
                                                        ),
                                                        staticClass:
                                                          "clickable",
                                                        attrs: {
                                                          "data-ref": _vm.createCellIdentificationData(
                                                            cellProps
                                                          )
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.setPopoverRefs(
                                                              $event,
                                                              cellProps
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              String(
                                                                cellProps.value
                                                              ) || "-"
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        ref: _vm.createCellIdentificationData(
                                                          cellProps
                                                        ),
                                                        attrs: {
                                                          "data-ref": _vm.createCellIdentificationData(
                                                            cellProps
                                                          )
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              String(
                                                                cellProps.value
                                                              ) || "-"
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    )
                                              ]
                                            },
                                            null,
                                            cellProps
                                          ),
                                          _vm._v(" "),
                                          _c("template", { slot: "popover" }, [
                                            _vm.createCellIdentificationData(
                                              cellProps
                                            ) == _vm.currentSelectedCell
                                              ? _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "click-outside",
                                                        rawName:
                                                          "v-click-outside",
                                                        value: {
                                                          binding:
                                                            _vm.removeCurrentSelectedCell,
                                                          focus:
                                                            ".popover--slim"
                                                        },
                                                        expression:
                                                          "{ binding: removeCurrentSelectedCell, focus: '.popover--slim' }"
                                                      }
                                                    ]
                                                  },
                                                  [
                                                    _vm.isLoadingPopoverData
                                                      ? _c("Loader", {
                                                          attrs: {
                                                            "custom-class":
                                                              "size-sm"
                                                          }
                                                        })
                                                      : _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "m-b-5"
                                                            },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .popoverData
                                                                      .title
                                                                  )
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.popoverData
                                                            .errorMessage
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "bs-callout bs-callout-danger p-5"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .popoverData
                                                                          .errorMessage
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "div",
                                                                _vm._l(
                                                                  _vm
                                                                    .popoverData
                                                                    .data,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return _c(
                                                                      "CopyText",
                                                                      {
                                                                        attrs: {
                                                                          text: item,
                                                                          useTooltip: false
                                                                        }
                                                                      }
                                                                    )
                                                                  }
                                                                ),
                                                                1
                                                              )
                                                        ])
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ])
                                        ],
                                        2
                                      )
                                    ]
                                  }
                                },
                                _vm._l(_vm.colSlots, function(slot) {
                                  return {
                                    key: slot,
                                    fn: function(slotProps) {
                                      return [
                                        _vm._t(slot, null, null, slotProps)
                                      ]
                                    }
                                  }
                                })
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }